import React, { useState } from 'react'
import { GiHamburgerMenu } from 'react-icons/gi'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'
import { BsFacebook, BsInstagram, BsLinkedin } from 'react-icons/bs'
import { VscSearch } from 'react-icons/vsc'
import { RxCross2 } from 'react-icons/rx'
import logo from './images/logo.svg'
import { Link } from 'react-router-dom'

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenMenu, setIsOpenMenu] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);

    };
    const menuList = () => {
        setIsOpenMenu(!isOpenMenu);
    };



    return (
        <>
            <div className="container-fluid    pt-[1rem] top-0 bg-white sticky z-50">

                {/* Navbar */}

                <div className="nav relative ">
                    <div className="flex md:mx-10 lg:mx-2 mx-2 justify-between">

                        <div className="lg:mx-[7rem] ">
                            <button>
                                <a href='/'><img src={logo} alt="" width="210px" /></a>
                            </button>
                        </div>

                        <div className="text-[2rem] text-[#004A8B]  lg:mx-20 mx-5 flex">
                            <div className="text-[15px]  relative hidden z-50 md:block">
                                {isOpen ? <button type='button' onClick={toggleDropdown} className='my-[1.2rem] mx-[2rem] font-black tracking-wider flex'>SEARCH LISTINGS <MdKeyboardArrowUp className='text-[1.5rem] mx-1 my-n2' /></button> :
                                    <button type='button' onClick={toggleDropdown} className='my-[1.2rem]  mx-[2rem]  font-black tracking-wider flex'>SEARCH LISTINGS <MdKeyboardArrowDown className='text-[1.5rem] mx-1 my-n2' /></button>}
                            </div>

                            <div className="my-[.8rem] font-black z-10"> {isOpenMenu ? <button type='button' onClick={menuList}><RxCross2 className='text-white hover:text-[#B5D1B3] text-[2.9rem] z-10' /></button> : <button type='button' className='text-[2.4rem] hover:text-gray-400 ' onClick={menuList}><GiHamburgerMenu /></button>}</div>

                        </div>
                    </div>
                </div>


                {/* Search Items */}
                {isOpen ? <div className="Search"></div> : ''}
                <div className={`${isOpen ? 'visible' : 'hidden'} bg-white pt-[5rem] my-[-5rem] px-8 lg:w-[20%] absolute top-[4.5rem] z-20 py-3  ml-[4rem] right-[5.5rem] lg:right-[7rem] items-center justify-center`}>
                    <div className="w-full my-2">
                        <select name="" id="" className=' w-full  border-b border-gray-100  py-3 text-[14px] focus:outline-none' >
                            <option value="" className=''>For Sale</option>
                            <option value="">Sold</option>
                        </select>
                    </div>
                    <div className="my-[1.1rem] w-full ">
                        <select name="" id="" className=' w-full focus:border-none focus:outline-none border-b border-gray-100   py-3 text-[14px]' >
                            <option value="">State</option>
                            <option value="">ACT</option>
                            <option value="">NSW</option>
                            <option value="">NT</option>
                            <option value="">QLD</option>
                            <option value="">TAS</option>
                            <option value="">VIC</option>
                            <option value="">WA</option>
                        </select>
                    </div>
                    <div className=" w-full my-[1rem]">
                        <input type="text" placeholder='SUBRUB' className='border-b border-gray-100 px-1 py-3 text-[14px] w-full focus:border-gray-100  outline-none  placeholder-black' />
                    </div>
                    <div className="w-full my-[1rem] ">
                        <select name="" id="" className=' w-full text-[14px] focus:outline-none border-b border-gray-100  py-3' >
                            <option value="" className=''>PROPERTY TYPE</option>
                            <option value="">Cotton</option>
                            <option value="">Cropy</option>
                            <option value="">Dairy</option>
                            <option value="">Development</option>
                            <option value="">Horticulture</option>
                            <option value="">LiveStocks</option>
                        </select>
                    </div>

                    <div className=" w-full ">
                        <input type="text" placeholder='MIN PRICE' className='border-b border-gray-100  px-1 py-3 text-[14px] w-full focus:border-gray-200 outline-none placeholder-black' />
                    </div>
                    <div className=" w-full py-3">
                        <input type="text" placeholder='MAX PRICE' className='border-b border-gray-100  px-1 py-3 text-[14px] w-full focus:border-gray-200 outline-none placeholder-black' />                    </div>
                    <div className=" w-full py-1">
                        <input type="text" placeholder='MIN AREA' className='border-b border-gray-100  px-1 py-3 text-[14px] w-full focus:border-gray-200 outline-none placeholder-black' />
                    </div>
                    <div className=" w-full  py-3  placeholder-black">
                        <input type="text" placeholder='MAX AREA' className='border-b border-gray-100  px-1 py-3 text-[14px] w-full focus:border-gray-200 outline-none placeholder-black' />                    </div>

                    <div className="bg-[#004A8B] hover:bg-[#B6D0B3] text-white w-full text-md font-black mt-[.4rem]">
                        <button className='py-2 px-2'>
                            <Link to='/Forsale' className='flex tracking-widest text-[13px]'><span className='py-1'>SEARCH NOW </span><VscSearch className='text-[1.7rem] ml-[2.8rem]' /></Link>
                        </button>
                    </div>


                </div>


                {/* Menu Button  */}

                <div className={`${isOpenMenu ? 'lg:w-[85%] w-[100%]' : 'w-0'} flex md:justify-center  z-0   absolute  bg-[#004A8B]  lg:rounded-[50%] md:top-[-18.5rem] top-[-3rem] lg:top-[-14rem] transitiona-ll duration-300  h-[58.5rem]   lg:right-[-22rem] right-[.1rem]  items-center overflow-hidden `}>

                    <div className="md:flex  overflow-hidden mt-[-6rem] md:pl-0 pl-[2rem] md:mt-[12rem] lg:mt-[12rem] ">

                        <div className='lg:pr-[8rem] md:pr-[3rem]'>
                            <button className='text-2xl text-white font-bold my-4 hover:text-[#B0C7DB]'><Link to='/'>Home</Link></button>
                            <h1 className='text-2xl text-white font-bold'>What we do</h1>
                            <button className='text-2xl text-white my-1 hover:text-[#B0C7DB]'><Link to='/Forsale'>For Sale</Link></button>

                            <button className='text-2xl block text-white  hover:text-[#B0C7DB]'><Link to='/Search'>Our Track record</Link></button>
                            <h1 className='text-2xl text-white my-1'>Our services</h1>
                            <button className='text-[1.3rem] flex  text-white  hover:text-[#B0C7DB]'><div className="w-[17px] h-[5px] my-4 bg-[#B5D1B3] mx-1"></div><Link to='/AdServices' className='mx-1'>Advisory</Link></button>
                            <button className='text-[1.3rem] flex  text-white  hover:text-[#B0C7DB]'><div className="w-[17px] h-[5px] my-4 bg-[#B5D1B3] mx-1"></div><Link to='/TranServices' className='mx-1'>Transaction</Link></button>
                            <button className='text-[1.3rem] flex  text-white  hover:text-[#B0C7DB]'><div className="w-[17px] h-[5px] my-4 bg-[#B5D1B3] mx-1"></div><Link to='/OurServices' className='mx-1 '>Valuations</Link></button>
                        </div>

                        <div className="mt-[1rem] lg:pr-[22rem]">
                            <h1 className='text-2xl text-white font-black'>About us</h1>
                            <button className='text-2xl text-white my-1 hover:text-[#B0C7DB]'><Link to='/OurStory'>Our Story</Link></button>

                            <button className='text-2xl block text-white  hover:text-[#B0C7DB]'><Link to='/Community'>Our Communities</Link></button>
                            <button className='text-2xl text-white my-1 hover:text-[#B0C7DB]'><Link to='/MetTeam'>Meet our team</Link></button>
                            <button className='text-2xl block text-white my-1 hover:text-[#B0C7DB]'><Link to='/Jointeam'>Join our team</Link></button>
                            <button className='text-2xl block font-bold my-4 text-white  hover:text-[#B0C7DB]'><Link to='/New'>News</Link></button>

                            <button className='text-2xl block font-bold  text-white  hover:text-[#B0C7DB]'><Link to='/Contact'>Connect</Link></button>

                            <button className=''><BsFacebook className='hover:text-[#B0C7DB] text-white my-9  text-3xl' /></button>
                            <button className=''><BsInstagram className='hover:text-[#B0C7DB] text-white my-9  text-3xl mx-2 ' /></button>
                            <button className=''><BsLinkedin className='hover:text-[#B0C7DB] text-white my-9  text-3xl mx-1 ' /></button>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default Navbar